import React from "react";

function Pagination({
  pageIndex,
  handlePagination,
  visiblePages,
  hasNextPage,
}) {
  return (
    <React.Fragment>
      <ul className="pagination flex-center flex-wrap gap-16 mt-auto pt-30">
        <li className="page-item">
          <button
            className="btn btn-sm page-link h-40 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
            disabled={pageIndex === 0}
            // onClick={() =>
            //   setPageData((prevData) => ({
            //     ...prevData,
            //     pageIndex: prevData.pageIndex - 1,
            //   }))
            // }
            onClick={() => handlePagination("minus")}
          >
            <i className="ph-bold ph-arrow-left" />
          </button>
        </li>
        {visiblePages.map((page) => (
          <li
            key={page}
            className={`page-item ${page === pageIndex ? "active" : ""}`}
          >
            <button
              className="btn btn-sm page-link h-40 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
              // onClick={() =>
              //   setPageData((prevData) => ({
              //     ...prevData,
              //     pageIndex: page,
              //   }))
              // }
              onClick={() => handlePagination(page)}
            >
              {(page + 1).toString().padStart(2, "0")}
            </button>
          </li>
        ))}
        <li className="page-item">
          <button
            className="btn btn-sm page-link h-40 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
            disabled={!hasNextPage()}
            // onClick={() =>
            //   setPageData((prevData) => ({
            //     ...prevData,
            //     pageIndex: prevData.pageIndex + 1,
            //   }))
            // }
            onClick={() => handlePagination("add")}
          >
            <i className="ph-bold ph-arrow-right" />
          </button>
          {/* {!hasNextPage() && (

          )} */}
        </li>
      </ul>
    </React.Fragment>
  );
}

export default Pagination;
